import { motion } from "framer-motion";
import { SKILLS } from "@/lib/softskills";

export const SoftSkillsGrid = () => (
  <div data-testid="method-soft-skills" className="mt-20 md:mt-28">
    <p className="eyebrow mb-4">Le competenze del cambiamento</p>
    <h3 className="mb-10 max-w-4xl font-display text-3xl font-900 uppercase leading-none md:text-5xl">
      Le 9 <span className="text-[#c4dcca]">soft skills</span> che alleniamo.
    </h3>
    <div className="grid gap-px bg-[rgba(152,191,162,0.2)] md:grid-cols-2 lg:grid-cols-3">
      {SKILLS.map((s, i) => (
        <motion.div key={s.key} data-testid={`soft-skill-${s.key}`}
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6, delay: (i % 3) * 0.08 }}
          className="flex flex-col gap-4 bg-[#050807] p-7 transition-colors duration-300 hover:bg-[#0b120e] md:p-8">
          <span className="font-mono text-xs text-[#98bfa2]">{String(i + 1).padStart(2, "0")}</span>
          <h4 className="font-display text-2xl font-900 uppercase leading-none md:text-3xl">{s.name}</h4>
          <p className="text-base leading-relaxed text-[#a3b1aa]">{s.desc}</p>
          <p className="mt-auto border-l-2 border-[#98bfa2] pl-3 text-sm italic text-[#c4dcca]">«{s.quote}»</p>
        </motion.div>
      ))}
    </div>
  </div>
);
